import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Table } from 'react-bootstrap';
import Navwrapper from '../../layout/Navigation';
import Footer from '../../layout/Footer';
import { getTeams } from '../api'

export default class TeamsPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      teamsData: []
    };
  }

  componentDidMount() {
    const _this = this
    getTeams(/*seasonId*/0).then(function (response) {
      _this.setState({ teamsData: response.data });
    });
  }

  loadTeamsTableData(teams) {
    const teamsAD = teams.filter(o => { return o.tabKey == 1 });
    const teamsEL = teams.filter(o => { return o.tabKey == 2 });
    const teamsMO = teams.filter(o => { return o.tabKey == 3 });
    const teamsPS = teams.filter(o => { return o.tabKey == 4 });
    const teamsTZ = teams.filter(o => { return o.tabKey == 5 });

    const arrays = [];

    let longestCount = teamsAD.length;
    longestCount = longestCount < teamsEL.length ? teamsEL.length : longestCount;
    longestCount = longestCount < teamsMO.length ? teamsMO.length : longestCount;
    longestCount = longestCount < teamsPS.length ? teamsPS.length : longestCount;
    longestCount = longestCount < teamsTZ.length ? teamsTZ.length : longestCount;

    for (let i = 0; i < longestCount; i++) {
      const array = [];
      array.push(teamsAD[i] ? teamsAD[i] : {});
      array.push(teamsEL[i] ? teamsEL[i] : {});
      array.push(teamsMO[i] ? teamsMO[i] : {});
      array.push(teamsPS[i] ? teamsPS[i] : {});
      array.push(teamsTZ[i] ? teamsTZ[i] : {});
      arrays.push(array);
    }
    return arrays;
  }

  render() {
    const teams = this.state.teamsData;

    const teamsTable = this.loadTeamsTableData(teams);

    return (
      <div>
        <Navwrapper />
        <div className="container-fluid">
          <Row>
            <div className="pageHeading" >
              <h4>
                {this.state.currentSeason}
              </h4>
              <h4 >
                Teams
              </h4>
            </div>
          </Row>
          <Table>
            <thead>
              <tr className='table-header-group'>
                <th>A-D</th>
                <th>E-L</th>
                <th>M-O</th>
                <th>P-S</th>
                <th>T-Z</th>
              </tr>
            </thead>
            <tbody>
              {
                teamsTable.map((row, i) => {
                  return (
                    <tr key={i}>
                      {
                        row.map((team, j) => {
                          return (
                            <td key={j}>
                              <Link to={"/teamplayers/" + team.teamId}>{team.schoolName}</Link>
                            </td>
                          );
                        })
                      }
                    </tr>
                  );
                })
              }
            </tbody>
          </Table>
        </div>
        <Footer />
      </div>
    );
  }
} 


// WEBPACK FOOTER //
// ./src/components/pages/teams/index.js